import {
  AppSettingsNavigationDTO,
  ClubClassesSettingsDTO
} from "@gymflow/types";
import { createContext } from "react";

export const AppSettingsContext = createContext<{
  navigationLocalData?: AppSettingsNavigationDTO;
  setNavigationLocalData: (data: AppSettingsNavigationDTO) => void;
  classesLocalData?: ClubClassesSettingsDTO;
  setClassesLocalData: (data: ClubClassesSettingsDTO) => void;
}>({
  navigationLocalData: undefined,
  setNavigationLocalData: () => {},
  classesLocalData: undefined,
  setClassesLocalData: () => {},
});
